var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_c('i',{staticClass:"checkerboard-item__infos",class:_vm.isDark ? 'dark' : 'light'},[_vm._v("i")]),_c('span',{staticClass:"tooltip__infos"},[_c('TextSimple',{attrs:{"size":"xxs"}},[_vm._v(_vm._s(_vm.infos))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }